export function gToKg(nb) {
  return nb / 1000;
}

export function lToM3(nb) {
  return nb / 1000;
}

export function kgToG(nb) {
  return nb * 1000;
}

export function m3ToL(nb) {
  return nb * 1000;
}
